"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _locizeLauncher = require("@influitive/locize-launcher");

var options = {
  defaultNs: 'SecretGarden',
  ns: 'SecretGarden'
};
var i18n = (0, _locizeLauncher.i18nLocizeInstance)(process.env.LOCIZE_PROJECT_ID || '8e532bc2-ae28-4290-8a86-071c4dbb904d', process.env.LOCIZE_API_KEY || '6e269c58-8d78-48d6-9d23-649fc2457d95', options);
var _default = i18n;
exports.default = _default;